"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfMarginsInfo = exports.SectionGutterAlignment = void 0;
var SectionGutterAlignment;
(function (SectionGutterAlignment) {
    SectionGutterAlignment[SectionGutterAlignment["Left"] = 0] = "Left";
    SectionGutterAlignment[SectionGutterAlignment["Right"] = 1] = "Right";
    SectionGutterAlignment[SectionGutterAlignment["Top"] = 2] = "Top";
    SectionGutterAlignment[SectionGutterAlignment["Bottom"] = 3] = "Bottom";
})(SectionGutterAlignment = exports.SectionGutterAlignment || (exports.SectionGutterAlignment = {}));
var RtfMarginsInfo = (function () {
    function RtfMarginsInfo() {
    }
    RtfMarginsInfo.prototype.copyFrom = function (obj) {
        this.gutter = obj.gutter;
        this.gutterAlignment = obj.gutterAlignment;
    };
    return RtfMarginsInfo;
}());
exports.RtfMarginsInfo = RtfMarginsInfo;
